import Widget from "Components/Common/Widget/Widget";
import React from "react";
import { GiVerticalBanner } from "react-icons/gi";
import { TbStarsFilled } from "react-icons/tb";
import { FaUsers } from "react-icons/fa6";
import BannersList from "./components/BannersList";

const Banner = () => {
  return (
    <React.Fragment>
      {/* Widgets Section */}
      {/* <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<GiVerticalBanner className="h-6 w-6" />}
          title={"Our Total Banners"}
          subtitle={"64"}
        />
        <Widget
          icon={<TbStarsFilled className="h-6 w-6" />}
          title={"No. of Special Banners"}
          subtitle={"34"}
        />
        <Widget
          icon={<FaUsers className="h-6 w-6" />}
          title={"Banners for Everyone"}
          subtitle={"23"}
        />
      </div> */}

      {/* Main Banner List Section */}
      <BannersList />
    </React.Fragment>
  );
};

export default Banner;
